module.exports = __webpack_public_path__ + "lp/img/icon_3dots.3c583812.svg";